<template>
  <div class="rounded-md bg-red-50 p-4" v-if='props.error'>
    <div class="flex">
      <div class="flex-shrink-0">
        <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <h2 class="text-sm font-medium text-red-800">{{ props.error.message }}</h2>
        <div class="mt-2 text-sm text-red-700" v-if='props.error.details?.length'>
          <ul role="list" class="list-disc space-y-1 pl-5">
            <li v-for='detail in props.error.details'>{{ detail.message }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  
import { XCircleIcon } from '@heroicons/vue/20/solid';

const props = defineProps({
  error: Object
});

</script>